// extracted by mini-css-extract-plugin
export default {"SidebarDivider":"style_SidebarDivider__l+QdP"};